import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CountryHoliday  {
    _originalTypeClassName = "ekylikeio.BO.CountryHoliday";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CountryHoliday.translate = translateService;
}
this.Id = null;
this.Date = null;
this.Name = null;
this.Type = null;
this.IsWorkingDay = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
Name:any;
Type:any;
IsWorkingDay:any;
Country:any;
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
if (oldValue != null) {
Domain.Country.removeHolidays(oldValue, $this);
}
Domain.Country.addHolidays(value, $this);
}
}

static GetNDays(country: any,referenceDate: any,nDay: any,onlyWorkingDays: any,isStart: any): any{let date = new Date(new Date(referenceDate)?.setHours(0, 0, 0, 0));
let countedDays = 1;
let step = (isStart ? 1 : -1);
while (CLMS.Framework.Number.LessThan(() => countedDays, () => nDay)) {if (onlyWorkingDays) {if (Domain.CountryHoliday.IsDateAWorkingDay(country, date)) {countedDays = Joove.Common.safeNumber(countedDays) + Joove.Common.safeNumber(1);}}else {countedDays = Joove.Common.safeNumber(countedDays) + Joove.Common.safeNumber(1);}date = (moment(date).add(step, "d")).toDate();}
return date;
}
static GetNDaysAfter(country: any,referenceDate: any,nDay: any,onlyWorkingDays: any): any{let date = new Date(new Date(referenceDate)?.setHours(0, 0, 0, 0));
let countedDays = 1;
while (CLMS.Framework.Number.LessThan(() => countedDays, () => nDay)) {if (onlyWorkingDays) {if (Domain.CountryHoliday.IsDateAWorkingDay(country, date)) {countedDays = Joove.Common.safeNumber(countedDays) + Joove.Common.safeNumber(1);}}else {countedDays = Joove.Common.safeNumber(countedDays) + Joove.Common.safeNumber(1);}date = (moment(date).add(1, "d")).toDate();}
return date;
}
static GetNDaysBefore(country: any,referenceDate: any,nDay: any,onlyWorkingDays: any): any{let date = new Date(new Date(referenceDate)?.setHours(0, 0, 0, 0));
let countedDays = 1;
while (CLMS.Framework.Number.LessThan(() => countedDays, () => nDay)) {if (onlyWorkingDays) {if (Domain.CountryHoliday.IsDateAWorkingDay(country, date)) {countedDays = Joove.Common.safeNumber(countedDays) + Joove.Common.safeNumber(1);}}else {countedDays = Joove.Common.safeNumber(countedDays) + Joove.Common.safeNumber(1);}date = (moment(date).add(-1, "d")).toDate();}
return date;
}
static IsDateAWorkingDay(country: any,date: any): any{if ((country == null || date == null)) {return false;}
return !(Domain.CountryHoliday.IsHoliday(country, date)) && CLMS.Framework.Number.NotEqual(() => moment(date).day(), () => 0) && CLMS.Framework.Number.NotEqual(() => moment(date).day(), () => 6);
}
static IsHoliday(country: any,date: any): any{if (date == null || (new Date(date).getTime()) == (new Date().getTime()) || (new Date(date).getTime()) == (new Date(moment(-8640000000000000).toDate()).getTime())) {throw Error("IsHoliday: Incorrect refDate: " + date);}
let holiday = country?.Holidays?.linq?.where((a) => a?.Country == country && (new Date(new Date(new Date(a?.Date)?.setHours(0, 0, 0, 0))).getTime()) == (new Date(new Date(new Date(date)?.setHours(0, 0, 0, 0))).getTime()))?.firstOrDefault(null);
let isHoliday = holiday != null && !(holiday?.IsWorkingDay);
console.debug("Holiday entry for date " + CLMS.Framework.DateTime.ToString(date, "dd/MM/yyyy") + " was " + ((holiday == null ? "NULL" : "NOT NULL")));
console.debug(CLMS.Framework.DateTime.ToString(new Date(new Date(date)?.setHours(0, 0, 0, 0)), "dd/MM/yyyy") + " is " + ((isHoliday ? "" : "NOT ")) + "a holiday!");
return isHoliday;
}
static IsHolidayToday(country: any): any{return Domain.CountryHoliday.IsHoliday(country, moment().toDate());
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}